var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.438,
    height: 18,
    viewBox: "0 0 13.438 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1760",
    "data-name": "Rectangle 1760",
    width: 13.438,
    height: 18,
    fill: "#610D24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2656",
    "data-name": "Group 2656",
    transform: "translate(-181 -503.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2655",
    "data-name": "Group 2655",
    transform: "translate(181 503.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    d: "M89.54,0V5.057H94.6Z",
    transform: "translate(-81.159 0)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2654",
    "data-name": "Group 2654",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    "data-name": "Path 3708",
    d: "M8.256,6.741a.751.751,0,0,1-.75-.75V.81H1.12A1.122,1.122,0,0,0,0,1.931V17.608a1.122,1.122,0,0,0,1.12,1.121h11.2a1.121,1.121,0,0,0,1.12-1.121V6.741ZM4.479,16.489H2.24v-3.36H4.479Zm3.36,0H5.6v-5.6h2.24Zm3.36,0H8.959V8.649H11.2Z",
    transform: "translate(0 -0.729)",
    fill: "#610D24"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedInvestment);
export default __webpack_public_path__ + "static/media/selected_investment.b6e6081ac2287f391861d28a7b8b73e3.svg";
export { ForwardRef as ReactComponent };